const MT_TARIFF_VARIANTS = {
	small: "smaller items",
	big: "bigger items"
};
const MT_TARIFF_IDS = {
	big: 44362533470384,
	small: 44362533503152
};
const MT_TARIFF_KEY = "tariff surcharge";
const MT_TARIFF_WATCH_TIMEOUT = 10;

let MT_TARIFF_BIG_ITEMS = [];
let MT_TARIFF_SMALL_ITEMS = [];
let MT_TARIFF_TOOLTIP = "The tariff surcharge on your order helps cover increased import taxes to make our products. We do our best to keep costs low while maintaining the quality you expect and supporting our mission to ensure everyone has access to period care.";

(() => {
	let isRunning = false;

	document.addEventListener("DOMContentLoaded", run);

	async function run() {
		if (window.tariff_big_product) {
			MT_TARIFF_BIG_ITEMS = window.tariff_big_product.map(product => product?.title.toLowerCase());
		}

		if (window.tariff_small_product) {
			MT_TARIFF_SMALL_ITEMS = window.tariff_small_product.map(product => product?.title.toLowerCase());
		}

		if (window.tariff_tooltip) {
			MT_TARIFF_TOOLTIP = window.tariff_tooltip;
		}

		setInterval(async () => {
			if (isRunning) {
				return;
			}

			isRunning = true;

			const isB2B = document.body.classList.contains("b2b_customer");

			let items = document.querySelectorAll(isB2B ?
				".cart__form .cart__table-body .cart__table-row" :
				".rebuy-cart__flyout-items .rebuy-cart__flyout-item"
			);

			let subtotalSection = document.querySelector(isB2B ?
				".checkout-buttons .cart-total-price" :
				".rebuy-cart__flyout-footer .rebuy-cart__flyout-subtotal"
			);

			let selectors = {
				title: isB2B ? ".cart-product__desc a" : ".rebuy-cart__flyout-item-product-title",
				variant: isB2B ? ".cart-product__desc .cart-product__variant" : ".rebuy-cart__flyout-item-variant-title",
				quantity: isB2B ? ".cart-product__quantity input" : ".rebuy-cart__flyout-item-quantity-widget-label",
				subscription: isB2B ? "cart-product__selling-plan-name" : ".rebuy-cart__flyout-item-subscription select",
				price: isB2B ? ".cart-product__price" : ".rebuy-money"
			}

			const bigItemCount = countItems(Array.from(items), MT_TARIFF_BIG_ITEMS, selectors);
			const smallItemCount = countItems(Array.from(items), MT_TARIFF_SMALL_ITEMS, selectors);
			const tariffItemCount = countTariffItems(Array.from(items), selectors);

			const isOutOfSync = (bigItemCount !== tariffItemCount.big || smallItemCount !== tariffItemCount.small);

			updateTariffPrice(subtotalSection, tariffItemCount.price);

			if (isOutOfSync) {
				const bigTariffQuantity = tariffItemCount.big - bigItemCount;
				const smallTariffQuantity = tariffItemCount.small - smallItemCount;

				setTimeout(async () => {
					if (bigTariffQuantity !== 0) {
						await fetchAddToCart(MT_TARIFF_IDS.big, bigItemCount);
					}

					if (smallTariffQuantity !== 0) {
						await fetchAddToCart(MT_TARIFF_IDS.small, smallItemCount);
					}

					isRunning = false;
				},isB2B ? 750 : 10);
			}

			else {
				isRunning = false;
			}
		}, MT_TARIFF_WATCH_TIMEOUT);
	}

	function updateTariffPrice(below, price) {
		let tariffPriceContainer;

		const existingTariffPriceContainer = document.querySelector(".tariff-price-container");

		if (existingTariffPriceContainer) {
			tariffPriceContainer = existingTariffPriceContainer;
		}

		else {
			tariffPriceContainer = document.createElement("div");
			tariffPriceContainer.classList.add("tariff-price-container");
		}

		tariffPriceContainer.classList.toggle("hidden", price === 0);

		tariffPriceContainer.innerHTML = `
					<div class="label">
						<span>
							Tariff Surcharge
						</span>
				      
			      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="tooltip-icon">
			        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
			      </svg>
					</div>
					
					<div class="rebuy-money">
						<span class="rebuy-money__price rebuy-cart__flyout-subtotal">
							$${price.toFixed(2)}
						</span>
					</div>
				`;

		setTimeout(() => {
			tippy('.tooltip-icon', {
				arrow: true,
				placement: 'top',
				content: MT_TARIFF_TOOLTIP
			});
		}, 0);

		if (below) {
			below.after(tariffPriceContainer);
		}
	}

	function countItems(items, itemList, selectors) {
		return items.reduce((count, item) => {
			const titleElement = item.querySelector(selectors.title);
			const quantityElement = item.querySelector(selectors.quantity);

			const title = titleElement.textContent;
			const quantityText = quantityElement.textContent.trim();
			const quantity = parseInt(quantityElement.value || quantityText[quantityText.length - 1]);

			const subscriptionContainer = item.querySelector(selectors.subscription);
			const isTrackedItem = itemList.some((bigItem) => title.toLowerCase().includes(bigItem));

			if (subscriptionContainer || !isTrackedItem) {
				return count;
			}

			return count + quantity;
		}, 0);
	}

	function countTariffItems(items, selectors) {
		return items.reduce((count, item) => {
			const titleElement = item.querySelector(selectors.title);
			const variantElement = item.querySelector(selectors.variant);
			const quantityElement = item.querySelector(selectors.quantity);
			const priceElement = item.querySelector(selectors.price);

			const title = titleElement?.textContent;
			const variant = variantElement?.textContent;
			const quantityText = quantityElement?.textContent.trim();
			const quantity = parseInt(quantityElement.value || quantityText[quantityText.length - 1]);

			if (title.toLowerCase().includes(MT_TARIFF_KEY)) {
				const priceText = priceElement?.textContent.trim().replace("Price", "").replace("$", "");

				count.price += parseFloat(priceText || 0) * quantity;

				if (variant.toLowerCase().includes(MT_TARIFF_VARIANTS.small)) {
					count.small += quantity;
				} else if (variant.toLowerCase().includes(MT_TARIFF_VARIANTS.big)) {
					count.big += quantity;
				}
			}

			return count;
		}, { small: 0, big: 0, price: 0 });
	}

	async function fetchAddToCart(id, quantity) {
		await fetch("/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				updates: {
					[id]: quantity,
				}
			})
		});

		document.dispatchEvent(new CustomEvent('theme:cart:custom:update'));
	}
})();
